// extracted by mini-css-extract-plugin
export default {"root":"Chip_root__x0NSX"};